exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* prevents bg color from leaking outside the border */\n\n/* Override Bootstrap buttons */\n\n.userAvatar {\n  color: #565c63;\n  -webkit-border-radius: 38px;\n  -moz-border-radius: 38px;\n  -ms-border-radius: 38px;\n  border-radius: 38px;\n  text-align: center;\n  width: 45px;\n  height: 45px;\n  line-height: 45px;\n  margin: 0 auto;\n  font-size: 15px;\n  background-color: #DBDCDD;\n  font-weight: 300;\n  display: inline-block;\n}\n\n.userAvatar--small {\n  color: #565c63;\n  -webkit-border-radius: 100%;\n  -moz-border-radius: 100%;\n  -ms-border-radius: 100%;\n  border-radius: 100%;\n  width: 30px;\n  height: 30px;\n  margin: 0 auto;\n  background-color: #DBDCDD;\n  line-height: 30px;\n  font-size: 12px;\n  font-weight: 300;\n  display: inline-block;\n}\n\n.userAvatar img,\n.userAvatar--small img {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.userAvatar:before,\n.userAvatar--small:before {\n  content: attr(content);\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/components/user-avatar.scss
// module id = 595
// module chunks = 0